import React, { Component } from 'react'
import { WithStylesProps } from 'react-jss'
import PartnerHeader from 'tfs.partner-header'
import { AuthenticatedTemplate } from '@azure/msal-react'

import styles from './App.styles'
import ErrorMessage from '../ErrorMessage'
import AppFooter from '../AppFooter'
import Router from '../../Router'
import navigationData from '../../config/navigationData'
import { msalInstance } from '../../msalClient'
import cypressAppReady from '../../utils/cypressAppReady'
import User from '../../models/User'

type AppProps = {
  error: { message: string }
  isAuthenticated: boolean
  user: User
  shouldLoadAirports: boolean
  getAirports: () => void
  setUserTOPCode: () => void
  requestUser: () => void
} & WithStylesProps<typeof styles>

class App extends Component<AppProps> {
  componentDidMount() {
    this.props.setUserTOPCode()
    this.props.requestUser()

    cypressAppReady(window)
  }
  componentDidUpdate() {
    const { isAuthenticated, user, shouldLoadAirports } = this.props

    if (isAuthenticated && !user.isFetching) {
      this.verifyRedirectionRulesBasedOnUserRoles(user.roles)
      if (shouldLoadAirports) {
        this.props.getAirports()
      }
    }
  }
  private verifyRedirectionRulesBasedOnUserRoles(roles: string[]) {
    if (roles.length === 0) {
      msalInstance.logoutRedirect()
    }
    else if (roles.includes('Admin') || roles.includes('Allotment')) {
      return
    }
    else if (roles.length === 1 && roles.includes('GroupOffer')) {
      window.location.assign(this.getRedirectPath('groupoffers', 'request_quote'))
    }
    else {
      window.location.assign(this.getRedirectPath('allotments_title', 'buy_allotments'))
    }
  }
  private getRedirectPath(linkKey: string, navLabel: string) {
    return navigationData.links
      .find((link: any) => link.key === linkKey)
      .subNavigation
      .find((subNav: any) => subNav.label === navLabel)
      .url
  }
  private getNavigationDataForUserRole(roles: string[]) {
    const allotmentLinks = navigationData.links.find((navData: any) => navData.key === 'allotments_title')
    if (allotmentLinks?.subNavigation && !allotmentLinks.subNavigation.some((navItem: any) => navItem.label === 'Baseload')) {
      const baseLoadLink = { label: 'Baseload', url: '/allotments' }
      allotmentLinks.subNavigation = [baseLoadLink, ...allotmentLinks.subNavigation]
    }

    if (roles.length === 0 || roles.includes('Admin')) {
      return navigationData.links
    }

    const navLinks = []
    const groupOfferLinks = navigationData.links.find((navData: any) => navData.key === 'groupoffers')

    if (roles.includes('Allotment')) {
      const allotmentManageNavItems = allotmentLinks.subNavigation.filter((navItem: any) => navItem.label !== 'buy_allotments' && navItem.label !== 'Baseload')
      navLinks.push({
        ...allotmentLinks,
        subNavigation: allotmentManageNavItems
      })
    }

    if (roles.includes('GroupOffer')) {
      navLinks.push(groupOfferLinks)
    }

    if (roles.includes('Quotes')) {
      const allotmentBuyNavItems = allotmentLinks.subNavigation.filter((navItem: any) => navItem.label === 'buy_allotments')

      if (navLinks.some((navData: any) => navData.key === 'allotments_title')) {
        navLinks.find((navData: any) => navData.key === 'allotments_title').subNavigation.unshift(allotmentBuyNavItems[0])
      }
      else {
        navLinks.push({
          ...allotmentLinks,
          subNavigation: allotmentBuyNavItems
        })
      }
    }

    if (roles.includes('BaseLoad')) {
      const allotmentBaseLoadItems = allotmentLinks.subNavigation.filter((navItem: any) => navItem.label === 'Baseload')

      if (navLinks.some((navData: any) => navData.key === 'allotments_title')) {
        navLinks.find((navData: any) => navData.key === 'allotments_title').subNavigation.unshift(allotmentBaseLoadItems[0])
      }
      else {
        navLinks.push({
          ...allotmentLinks,
          subNavigation: allotmentBaseLoadItems
        })
      }
    }

    return navLinks
  }
  render() {
    const { classes, error, isAuthenticated, user, ...rest } = this.props

    const appClassName = isAuthenticated
      ? classes.app
      : classes.appLogin

    return (
      <>
        <main className={appClassName}>
          <AuthenticatedTemplate>
            <div className={classes.mainNavigation}>
              <PartnerHeader
                logout={() => {
                  sessionStorage.clear()
                  msalInstance.logoutRedirect()
                }}
                navigationLinks={this.getNavigationDataForUserRole(user.roles)}
                username={user?.firstName}
                labels={navigationData.labels}
                homeUrl={navigationData['home-url']}
              />
            </div>
          </AuthenticatedTemplate>
          {error.message && <ErrorMessage message={error.message} />}

          <Router />
        </main>
        <AppFooter />
      </>
    )
  }
}

export default App
